var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 413 413",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18323_2961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3024 214.251C65.3024 251.539 80.1152 287.3 106.482 313.667C132.849 340.034 168.61 354.846 205.898 354.846C243.186 354.846 278.948 340.034 305.314 313.667C331.681 287.3 346.494 251.539 346.494 214.251C346.494 176.962 331.681 141.201 305.314 114.834C278.948 88.4676 243.186 73.6549 205.898 73.6549C168.61 73.6549 132.849 88.4676 106.482 114.834C80.1152 141.201 65.3024 176.962 65.3024 214.251V214.251Z",
    fill: "#E9F0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.364 318.906C156.364 320.514 161.583 322.056 170.873 323.193C180.162 324.33 192.762 324.969 205.899 324.969C219.037 324.969 231.637 324.33 240.926 323.193C250.216 322.056 255.435 320.514 255.435 318.906C255.435 317.298 250.216 315.756 240.926 314.619C231.637 313.481 219.037 312.843 205.899 312.843C192.762 312.843 180.162 313.481 170.873 314.619C161.583 315.756 156.364 317.298 156.364 318.906V318.906Z",
    fill: "#686B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.541 221.696L144.494 232.796L148.515 288.865C149.303 288.34 149.898 287.572 150.213 286.679L169.678 224.726C169.989 223.731 169.941 222.658 169.541 221.696Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.494 232.793L169.541 221.693V221.665C169.133 220.705 168.398 219.921 167.467 219.451L146.48 208.839C145.314 208.249 144.032 207.925 142.726 207.89L144.512 232.8L144.494 232.793Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.705 207.887C141.388 207.851 140.079 208.109 138.874 208.642L116.378 218.604L144.477 232.797L142.705 207.887Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.396 218.603L108.037 248.951L144.494 232.796L116.396 218.603Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.037 248.951L146.873 289.594C147.175 289.565 147.474 289.503 147.763 289.411C148.025 289.258 148.272 289.077 148.497 288.873L144.494 232.796L108.037 248.951Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9896 260.05L108.037 248.95L146.873 289.593C145.954 289.826 144.983 289.752 144.11 289.382L85.1442 262.187C84.1972 261.75 83.4344 260.993 82.9896 260.05V260.05Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.037 248.951L82.9898 260.051V260.019C82.5517 259.073 82.4632 258.002 82.7403 256.996L88.9757 234.322C89.3243 233.062 89.9459 231.894 90.7964 230.902L108.051 248.958L108.037 248.951Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7824 230.895C91.6423 229.896 92.7131 229.1 93.9177 228.564L116.413 218.603L108.055 248.951L90.7824 230.895Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.628 234.094L260.671 245.191L256.654 301.26C255.866 300.735 255.272 299.967 254.96 299.074L235.498 237.12C235.181 236.128 235.227 235.055 235.628 234.094V234.094Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.672 245.184L235.628 234.091V234.063C236.037 233.104 236.771 232.319 237.702 231.849L258.69 221.234C259.858 220.648 261.14 220.324 262.447 220.285L260.658 245.195L260.672 245.184Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.457 220.278C263.775 220.242 265.085 220.5 266.292 221.034L288.787 230.995L260.689 245.185L262.457 220.278Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.77 230.994L297.132 261.342L260.672 245.184L288.77 230.994Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.131 261.342L258.292 301.985C257.991 301.954 257.694 301.893 257.406 301.802C257.144 301.651 256.898 301.472 256.675 301.268L260.692 245.195L297.131 261.342Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.174 272.438L297.131 261.341L258.291 301.984C259.209 302.217 260.178 302.143 261.05 301.773L320.023 274.575C320.971 274.14 321.733 273.382 322.174 272.438V272.438Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.132 261.342L322.176 272.439V272.41C322.611 271.463 322.698 270.393 322.422 269.388L316.186 246.71C315.839 245.45 315.217 244.284 314.366 243.293L297.114 261.349L297.132 261.342Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.382 243.286C313.524 242.286 312.455 241.49 311.25 240.956L288.755 230.994L297.117 261.342L314.382 243.286Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.596 121.219L134.389 117.286C134.612 117.215 134.807 117.074 134.945 116.885C135.084 116.695 135.158 116.466 135.158 116.232C135.158 115.997 135.084 115.769 134.945 115.579C134.807 115.39 134.612 115.249 134.389 115.177L124.698 111.947C124.043 111.729 123.448 111.362 122.96 110.874C122.471 110.386 122.104 109.79 121.886 109.135L118.663 99.4728C118.593 99.2476 118.453 99.0505 118.264 98.9105C118.074 98.7706 117.844 98.6951 117.608 98.6951C117.373 98.6951 117.143 98.7706 116.953 98.9105C116.764 99.0505 116.624 99.2476 116.554 99.4728L113.324 109.163C113.106 109.819 112.739 110.414 112.251 110.902C111.762 111.39 111.167 111.758 110.512 111.975L100.814 115.209C100.589 115.279 100.392 115.419 100.252 115.608C100.112 115.798 100.036 116.028 100.036 116.263C100.036 116.499 100.112 116.729 100.252 116.919C100.392 117.108 100.589 117.248 100.814 117.318L110.512 120.552C111.167 120.769 111.762 121.137 112.251 121.625C112.739 122.113 113.106 122.708 113.324 123.364L116.557 133.065C116.629 133.288 116.77 133.483 116.959 133.621C117.149 133.76 117.377 133.834 117.612 133.834C117.847 133.834 118.075 133.76 118.265 133.621C118.454 133.483 118.595 133.288 118.666 133.065L122.596 121.219Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.906 161.359L348.699 157.425C348.922 157.354 349.117 157.213 349.256 157.024C349.394 156.834 349.468 156.606 349.468 156.371C349.468 156.136 349.394 155.908 349.256 155.718C349.117 155.529 348.922 155.388 348.699 155.317L339.008 152.086C338.353 151.869 337.758 151.501 337.27 151.013C336.782 150.525 336.414 149.929 336.196 149.274L332.966 139.584C332.895 139.36 332.754 139.165 332.564 139.027C332.375 138.889 332.146 138.814 331.912 138.814C331.677 138.814 331.448 138.889 331.259 139.027C331.069 139.165 330.929 139.36 330.857 139.584L327.627 149.274C327.409 149.929 327.041 150.524 326.553 151.013C326.065 151.501 325.47 151.868 324.815 152.086L315.114 155.317C314.891 155.388 314.696 155.529 314.557 155.718C314.419 155.908 314.344 156.136 314.344 156.371C314.344 156.606 314.419 156.834 314.557 157.024C314.696 157.213 314.891 157.354 315.114 157.425L324.815 160.656C325.471 160.873 326.066 161.24 326.554 161.728C327.043 162.216 327.41 162.812 327.627 163.468L330.861 173.165C330.932 173.389 331.073 173.584 331.262 173.722C331.452 173.86 331.681 173.935 331.915 173.935C332.15 173.935 332.378 173.86 332.568 173.722C332.757 173.584 332.898 173.389 332.97 173.165L336.906 161.359Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.823 106.214C265.196 104.597 266.016 103.117 267.189 101.943C268.363 100.769 269.842 99.9486 271.459 99.5748L284.784 96.5027C285.028 96.4451 285.245 96.3071 285.4 96.1109C285.555 95.9148 285.639 95.672 285.639 95.4219C285.639 95.1718 285.555 94.9291 285.4 94.7329C285.245 94.5368 285.028 94.3987 284.784 94.3411L271.459 91.2691C269.842 90.8968 268.361 90.0766 267.188 88.9024C266.014 87.7283 265.195 86.2475 264.823 84.6294L261.748 71.315C261.692 71.0708 261.554 70.8529 261.358 70.6968C261.162 70.5407 260.919 70.4558 260.669 70.4558C260.418 70.4558 260.175 70.5407 259.979 70.6968C259.783 70.8529 259.646 71.0708 259.59 71.315L256.518 84.6294C256.145 86.2477 255.324 87.7285 254.15 88.9031C252.976 90.0777 251.496 90.8987 249.878 91.2726L236.553 94.3411C236.31 94.3987 236.093 94.5368 235.938 94.7329C235.783 94.9291 235.698 95.1718 235.698 95.4219C235.698 95.672 235.783 95.9148 235.938 96.1109C236.093 96.3071 236.31 96.4451 236.553 96.5027L249.867 99.5748C251.485 99.9484 252.965 100.769 254.139 101.943C255.313 103.117 256.133 104.597 256.507 106.214L259.579 119.539C259.635 119.784 259.772 120.001 259.968 120.158C260.164 120.314 260.408 120.399 260.658 120.399C260.909 120.399 261.152 120.314 261.348 120.158C261.544 120.001 261.681 119.784 261.737 119.539L264.823 106.214Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.268 186.412L250.798 182.795L210.123 273.866C211.796 273.704 213.37 273.002 214.608 271.866L296.945 191.269C298.267 189.974 299.09 188.254 299.268 186.412V186.412Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.798 182.796L299.268 186.412V186.346C299.43 184.5 298.932 182.656 297.862 181.144L273.926 146.968C272.598 145.078 270.871 143.502 268.868 142.353L250.798 182.81V182.796Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.869 142.353C266.838 141.191 264.573 140.498 262.24 140.325L218.739 137.081L250.799 182.81L268.869 142.353Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.738 137.067L180.247 177.531L250.798 182.796L218.738 137.067Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.247 177.53L206.96 273.627C207.457 273.833 207.974 273.986 208.503 274.084H208.524H208.542C209.079 274.064 209.612 273.99 210.134 273.862L250.808 182.791L180.247 177.53Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.777 173.915L180.247 177.532L206.96 273.629C205.327 273.23 203.869 272.307 202.809 271L133.355 179.061C132.237 177.586 131.678 175.763 131.777 173.915V173.915Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.247 177.531L131.776 173.914V173.843C131.891 172.002 132.65 170.26 133.921 168.923L162.669 138.695C164.268 137.017 166.217 135.711 168.377 134.87L180.243 177.562L180.247 177.531Z",
    fill: "#686B8C",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.381 134.841C170.561 133.995 172.903 133.646 175.235 133.818L218.739 137.08L180.247 177.529L168.381 134.841Z",
    fill: "white",
    stroke: "#002B58",
    strokeWidth: 4.39362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18323_2961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 413,
    height: 413,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCompleted);
export default __webpack_public_path__ + "static/media/PlanCompleted.4967e36c279f49b19945595565e3e751.svg";
export { ForwardRef as ReactComponent };